// @ts-nocheck
import * as Types from '../../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
export type FloorPlanOptionGroup_CheckoutOptionGroupFragment = { __typename?: 'CheckoutConfigOptionGroup', id: string, step: Types.CheckoutConfigOptionGroupStep, group: { __typename?: 'ReadyPlanOptionGroup', id: string, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string, marketingName: string, location: { __typename?: 'Location', id: string, name: string } } | null | undefined }, options: Array<{ __typename?: 'CheckoutConfigPotentialOption', id: string, isSelected: boolean, option: { __typename?: 'ReadyPlanOption', id: string, code: string } }> };

export const FloorPlanOptionGroup_CheckoutOptionGroupFragmentDoc = gql`
    fragment FloorPlanOptionGroup_CheckoutOptionGroup on CheckoutConfigOptionGroup {
  id
  step
  group {
    id
    readyPlanLocation {
      id
      marketingName
      location {
        id
        name
      }
    }
  }
  options {
    id
    isSelected
    option {
      id
      code
    }
  }
}
    `;